import { useState } from "react";
import { PopOverMenu } from "components/commons";
import { locale } from "localization/en";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import styles from "./order-summary-list.module.scss";
import { FormMode, Path, OrderStatus } from "enums";

const ValidatedPopOverMenu = ({ orders, history }) => {
  const [menuOptions, setMenuOptions] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const { orderId, status } = orders;

  const validatedOptions = [
    {
      content: locale.viewDetails,
      onClick: () => {
        history.push(Path.ViewOrderSummaryDetails(orderId, FormMode.View));
      },
    },
  ];

  const handleTriggerClick = async (event) => {
    const el = event.currentTarget;
    if (status === OrderStatus.Pending || status === OrderStatus.Processing) {
      validatedOptions.push({
        content: locale.editDetails,
        onClick: () => {
          history.push(Path.ViewOrderSummaryDetails(orderId, FormMode.Edit));
        },
      });
    }
    setMenuOptions(validatedOptions);
    setAnchorEl(el);
  };

  return (
    <PopOverMenu
      options={menuOptions}
      disabledClick={false}
      setActiveClicked={setAnchorEl}
      externalAnchorEl={anchorEl}
    >
      <div onClick={handleTriggerClick}>
        <MoreVertIcon className={styles.icon} />
      </div>
    </PopOverMenu>
  );
};

export default ValidatedPopOverMenu;
